/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  branch Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_LOSS(state, loss) {
    state.losses.unshift(loss);
    state.totalDataRow++;
  },
  SET_LOSSES(state, res) {
    state.losses = res.pageData.items
    state.totalDataRow = res.pageData.totalCount;
    state.totalPrice=res.totalPrice;
    state.totalPagePrice=res.pageTotalPrice;
    //state.losses = res.items
    //state.totalDataRow = res.totalCount;
  },
  UPDATE_LOSS(state, loss) {
    const productIndex = state.losses.findIndex((p) => p.id == loss.id)
    Object.assign(state.losses[productIndex], loss)
  },
  REMOVE_LOSS(state, lossId) {
    const lossIndex = state.losses.findIndex((p) => p.id == lossId)
    state.losses.splice(lossIndex, 1)
  },
  OPEN_LOSS(state,lossIndex){
    state.losses[lossIndex].isOpen = !state.losses[lossIndex].isOpen;
  }
}
